import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';

const ALL_LEV_ADMIN_GROUPS_QUERY_KEY = 'user-operations/levAdminGroups';

export function useGetAllLevAdminGroups() {
	const userSession = useAdminUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'admin/userOperations/levAdminGroups',
				}),
				'GET'
			);
		},
		queryKey: [ALL_LEV_ADMIN_GROUPS_QUERY_KEY],
		staleTime: 1000 * 60 * 60, // Cache for 1 hour since roles don't change often
	});
}
